import OrderTotals from './OrderTotals';

export default OrderTotals;
